import React from 'react';
import { useComponents } from '@tencent/dz-elements';
import styles from './style/index.less';
export var DISEASETABS = [
    {
        name: '概述',
        value: 1,
        content: 'overview',
    },
    {
        name: '病因',
        value: 2,
        content: 'pathogeny',
    },
    {
        name: '症状',
        value: 3,
        content: 'symptom',
    },
    {
        name: '治疗',
        value: 4,
        content: 'treat',
    },
    {
        name: '诊断',
        value: 5,
        content: 'diagnosis',
    },
    {
        name: '检查',
        value: 6,
        content: 'examination',
    },
    {
        name: '预防',
        value: 7,
        content: 'prevention',
    },
    {
        name: '并发症',
        value: 8,
        content: 'complication',
    },
];
export var DiseaseTabs = function (props) {
    var disease = props.disease, _a = props.type, type = _a === void 0 ? 'card' : _a, style = props.style, className = props.className, currentTab = props.currentTab, onChange = props.onChange, diseaseTabClickReport = props.diseaseTabClickReport;
    var _b = useComponents(), View = _b.View, Text = _b.Text, ScrollView = _b.ScrollView;
    var onClickTab = function (e, tabInfo) {
        diseaseTabClickReport(type, tabInfo.value, tabInfo.name);
        onChange(tabInfo.content);
        e.stopPropagation();
    };
    return (React.createElement(View, { className: styles['disease-detail'] + " " + className, style: style },
        React.createElement(View, { className: styles['disease-tab-container'] + " " + styles["disease-tab-container-" + type] },
            React.createElement(View, { className: styles['disease-tab'] }, DISEASETABS.map(function (disease, index) { return (React.createElement(View, { className: styles['disease-tab-item'] + " " + (currentTab === disease.content && styles.active), onClick: (function (e) { return onClickTab(e, disease); }), key: index },
                React.createElement(Text, { className: styles['tab-name'], content: disease.name }))); }))),
        type === 'card' && (React.createElement(View, { className: styles['disease-content'] + " " + styles['disease-content-card'] }, disease[currentTab])),
        type === 'modal' && (React.createElement(ScrollView, { className: styles['disease-content'] + " " + styles['disease-content-modal'] }, disease[currentTab]))));
};
